// export const ODINI_ICON = require('src/static/icon.png')
import ODINI_ICON from './Robowealth_logo.png'
import TOEXIT_ICON from './2EXT_logo.png'
import APPMAN_ICON from './Appman_logo.png'
import BITKUB_ICON from './Bitkub_logo.png'
import COLLECTIUS_ICON from './Collectius_logo.png'
import DEEP_SCOPE_ICON from './Deepscope_logo.png'
import DREAM_MAKER_ICON from './Dreamaker_logo.png'
import FINOMENA_ICON from './Finnomena_new logo.png'
import FUNDING_SOCIETY_ICON from './Funding society_logo.png'
import INNO_SW_CONSUL_ICON from './Innovative software consulting_logo.png'
import PRAIN_FINTECH_ICON from './Prainfintech_logo.png'
import PROMPT_NOW_ICON from './Promptnow_logo.png'
import REFINN_ICON from './Refinn_logo.png'
import SHOPEE_PAY_ICON from './ShopeePay_logo.png'
import SINWATTANA_ICON from './Sinwattana_logo.png'
import SMART_CONTRACT_ICON from './Smartcontract_logo.png'
import TCC_TECH_ICON from './TCC Technoloy_logo.png'
import TQD_ICON from './TQD_logo.png'
import TRUST_TENDER_ICON from './Trustender_logo.png'

import ANS_BROKERPAGE_ICON from './ANC Brokerage_logo.png'
import ASCO_ICON from './ASCO_logo.png'
import ASSET_WORLD_CORP_ICON from './Asset world corp_logo.png'
import ATATO_ICON from './Atato_logo.png'
import BCI_LOGO from './BCI_logo.png'
import BILL_ME_ICON from './Billme_logo.png'
import CHOMCHOB_ICON from './Chomchob_logo.png'
import CLAIM_DI_ICON from './Claimdi_logo.png'
import DATA_ONE_ICON from './Dataone_logo.png'
import DEE_MONEY_ICON from './Deemoney_logo.png'

import DOLLAR_SMART_ICON from './Dollarsmart_logo.png'
import DURIAN_CORP_ICON from './Durian Corp_logo.png'
import FRIENDS_FOR_DISABILITY_ICON from './Friends for Disability_logo.png'
import ILCT_ICON from './ILCT_logo.png'
import INVES_TREE_ICON from './investree_logo.png'
import J_VENTURE_ICON from './J Venture_logo.png'
import LUCKY_LEASING_ICON from './Lucky Leasing_logo.png'
import MASII_ICON from './Masii_logo.png'
import MONEY_WE_CAN_ICON from './Moneywecan_logo.jpeg'
import NAKORN_LEASING_ICON from './Nakorn leasing_logo.png'

import NESTIFY_ICON from './Nestify_logo.png'
import PEAK_ICON from './PEAK_logo.png'
import PEER_POWER_ICON from './Peerpower_logo.png'
import SIAM_VALIDUS_ICON from './Siam Validus_logo.png'
import SMART_FINN_ICON from './Smartfinn_logo.png'
import T2P_ICON from './T2P_logo.png'
import TAS_MAEW_ICON from './Tasmaew Insuranace_logo.png'
import THAI_BMA_ICON from './ThaiBMA_logo.png'
import TRIS_RATING_ICON from './Tris Rating_logo.png'
import TRUST_LESS_BANK_ICON from './Trustlessbank_logo.png'

import UP_BIT_ICON from './Upbit_logo.png'
import UTU_ICON from './UTU_logo.png'
import WEALTHI_ICON from './Wealthi_logo.png'
import ZIPMEX_ICON from './Zipmex_logo.png'
import MARKET_724 from './724 Market_logo.png'
//before 35

//after
import EXR_ICON from './ERX_Logo Member TFA.png'
import HUOBI_ICON from './Huobi_Logo Member TFA.png'
import SATANG_PRO_ICON from './SatangPro _Logo Member TFA.png'
import Z_ICON from './Z.Com_Logo Member TFA.png'



export const ICONS = {
    ODINI_ICON,
    TOEXIT_ICON,
    APPMAN_ICON,
    BITKUB_ICON,
    COLLECTIUS_ICON,
    DEEP_SCOPE_ICON,
    DREAM_MAKER_ICON,
    FINOMENA_ICON,
    FUNDING_SOCIETY_ICON,
    INNO_SW_CONSUL_ICON,
    PRAIN_FINTECH_ICON,
    PROMPT_NOW_ICON,
    REFINN_ICON,
    SHOPEE_PAY_ICON,
    SINWATTANA_ICON,
    SMART_CONTRACT_ICON,
    TCC_TECH_ICON,
    TQD_ICON,
    TRUST_TENDER_ICON,

    ANS_BROKERPAGE_ICON,
    ASCO_ICON,
    ASSET_WORLD_CORP_ICON,
    ATATO_ICON,
    BCI_LOGO,
    BILL_ME_ICON,
    CHOMCHOB_ICON,
    CLAIM_DI_ICON,
    DATA_ONE_ICON,
    DEE_MONEY_ICON,

    DOLLAR_SMART_ICON,
    DURIAN_CORP_ICON,
    FRIENDS_FOR_DISABILITY_ICON,
    ILCT_ICON,
    INVES_TREE_ICON,
    J_VENTURE_ICON,
    LUCKY_LEASING_ICON,
    MASII_ICON,
    MONEY_WE_CAN_ICON,
    NAKORN_LEASING_ICON,

    NESTIFY_ICON,
    PEAK_ICON,
    PEER_POWER_ICON,
    SIAM_VALIDUS_ICON,
    SMART_FINN_ICON,
    T2P_ICON,
    TAS_MAEW_ICON,
    THAI_BMA_ICON,
    TRIS_RATING_ICON,
    TRUST_LESS_BANK_ICON,

    UP_BIT_ICON,
    UTU_ICON,
    WEALTHI_ICON,
    ZIPMEX_ICON,
    MARKET_724,

    EXR_ICON,
    HUOBI_ICON,
    SATANG_PRO_ICON,
    Z_ICON,
}
